import { styled } from "theme/default/styled";

export const SPopUpContainerEmitter = styled.div`
  position: fixed;
  z-index: 1;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
